import { Helmet } from 'react-helmet';
import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
// Removed ClientsSection import
import TechnologySection from '../components/home/TechnologySection';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>VEDUS Supply Chain Management | Delivering Speed Globally</title>
        <meta name="description" content="VEDUS Supply Chain Management provides reliable logistics solutions for domestic and international shipping through road, air, train, and ship transport." />
      </Helmet>
      
      <Hero />
      <Services />
      <TechnologySection />
      {/* Removed ClientsSection component */}
    </>
  );
};

export default HomePage;